
/* injects from baggage-loader */

const moduleAlert = angular.module('update.link.controller', []);

moduleAlert.controller('LinkUpdateModal', [
  "$scope", "$state", "$rootScope", "$modalInstance", "$stateParams", "link", "widget",
  ($scope, $state, $rootScope, $modalInstance, $stateParams, link, widget) => {
    $scope.editlink = link;
    $scope.widget = widget;

    $scope.save = (editlink, form) => {
      if (form.$invalid) {
        return false;
      }
      $scope.close();
    };

    $scope.pageSelect = (path) => {
      $scope.editlink.url = "/" + angular.copy(path);
    };

    $scope.deleteLink = () => {
      $scope.editlink._destroy = true;
      $scope.close();
    };

    $scope.linksLength = () => {
      const destroyed = _.filter(widget.links_attributes, {
        _destroy: true
      });
      return widget.links_attributes.length - destroyed.length;
    };

    $scope.close = () => {
      $modalInstance.dismiss("close");
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/navigationfields/link.update.controller.js